import React, { useState, useEffect, useCallback } from 'react';

const BASE_URL = 'https://api.pixventa.com';
const DIAS = ['L','M','X','J','V','S','D'];

function formatPesos(num) {
  return '$' + Math.round(num).toLocaleString('es-MX');
}

function BarraEstado({ label, valor, max, color }) {
  const pct = max > 0 ? Math.round((valor / max) * 100) : 0;
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
        <span style={{ fontSize: 11, color: '#7A8F89' }}>{label}</span>
        <span style={{ fontSize: 11, fontWeight: 700, color }}>{valor}</span>
      </div>
      <div style={{ height: 14, background: '#F0F4F0', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: color, borderRadius: 4, transition: 'width .3s' }} />
      </div>
    </div>
  );
}

function Stats({ onNavegar }) {
  const [periodo,       setPeriodo]       = useState('hoy');
  const [fechaInicio,   setFechaInicio]   = useState('');
  const [fechaFin,      setFechaFin]      = useState('');
  const [pickerInicio,  setPickerInicio]  = useState('');
  const [pickerFin,     setPickerFin]     = useState('');
  const [mostrarCustom, setMostrarCustom] = useState(false);
  const [datos,         setDatos]         = useState(null);
  const [cargando,      setCargando]      = useState(true);

  const hoyStr = new Date().toISOString().split('T')[0];

  const cargarDatos = useCallback(async () => {
    setCargando(true);
    try {
      const [pedRes, prodRes] = await Promise.all([
        fetch(`${BASE_URL}/pedidos`),
        fetch(`${BASE_URL}/productos`),
      ]);
      const pedidos   = await pedRes.json();
      const productos = await prodRes.json();
      const ahora = new Date();
      const filtrar = (p) => {
        const fecha = new Date(p.creado_en);
        if (periodo === 'hoy') return fecha.toDateString() === ahora.toDateString();
        else if (periodo === 'semana') {
          const lunes = new Date(ahora);
          lunes.setDate(ahora.getDate() - (ahora.getDay() === 0 ? 6 : ahora.getDay() - 1));
          lunes.setHours(0,0,0,0);
          return fecha >= lunes;
        } else if (periodo === 'mes') {
          return fecha.getMonth() === ahora.getMonth() && fecha.getFullYear() === ahora.getFullYear();
        } else if (periodo === 'custom' && fechaInicio && fechaFin) {
          const ini = new Date(fechaInicio);
          const fin = new Date(fechaFin); fin.setHours(23,59,59);
          return fecha >= ini && fecha <= fin;
        }
        return true;
      };
      const todosLosPedidos = Array.isArray(pedidos) ? pedidos : [];
      const pedFiltrados    = todosLosPedidos.filter(filtrar);
      const ventas          = pedFiltrados.reduce((a, p) => a + parseFloat(p.total || 0), 0);
      const totalPedidos    = pedFiltrados.length;
      const porEstado = {
        entregado:  pedFiltrados.filter(p => p.estado === 'entregado' || p.estado === 'recogido').length,
        enviado:    pedFiltrados.filter(p => p.estado === 'enviado').length,
        pendiente:  pedFiltrados.filter(p => p.estado === 'pendiente').length,
        confirmado: pedFiltrados.filter(p => p.estado === 'confirmado').length,
        revision:   pedFiltrados.filter(p => p.estado === 'revision').length,
        cancelado:  pedFiltrados.filter(p => p.estado === 'cancelado').length,
      };
      const alertaNuevos    = todosLosPedidos.filter(p => p.estado === 'pendiente').length;
      const alertaRevision  = todosLosPedidos.filter(p => p.estado === 'revision').length;
      const alertaCancelado = todosLosPedidos.filter(p => p.estado === 'cancelado').length;
      const ventasPorDia = DIAS.map((_, i) => {
        const fecha = new Date(ahora);
        const diaSemana = ahora.getDay() === 0 ? 6 : ahora.getDay() - 1;
        fecha.setDate(ahora.getDate() - diaSemana + i);
        fecha.setHours(0,0,0,0);
        const fin = new Date(fecha); fin.setHours(23,59,59);
        const total = todosLosPedidos
          .filter(p => { const f = new Date(p.creado_en); return f >= fecha && f <= fin; })
          .reduce((a, p) => a + parseFloat(p.total || 0), 0);
        return Math.round(total);
      });
      const todasVariantes = productos.flatMap(p => (p.variantes || []).filter(v => v));
      const stockBajo = todasVariantes.filter(v => v.stock > 0 && v.stock <= 4).length;
      const agotados  = todasVariantes.filter(v => v.stock === 0).length;
      const conteoProductos = {};
      todosLosPedidos.forEach(p => {
        let items = p.items;
        if (typeof items === 'string') { try { items = JSON.parse(items); } catch { items = []; } }
        if (Array.isArray(items)) {
          items.forEach(it => {
            const key = it.nombre || 'Producto';
            if (!conteoProductos[key]) conteoProductos[key] = { emoji: it.emoji||'📦', nombre: it.nombre||'', qty: 0 };
            conteoProductos[key].qty += (it.cantidad || it.qty || 1);
          });
        }
      });
      const topProductos = Object.values(conteoProductos).sort((a,b) => b.qty - a.qty).slice(0, 4);
      const maxQty = topProductos.length > 0 ? topProductos[0].qty : 1;
      setDatos({ ventas, totalPedidos, porEstado, alertaNuevos, alertaRevision, alertaCancelado, ventasPorDia, stockBajo, agotados, topProductos, maxQty });
    } catch (e) { console.error(e); }
    setCargando(false);
  }, [periodo, fechaInicio, fechaFin]);

  useEffect(() => { cargarDatos(); }, [cargarDatos]);

  function aplicarCustom() {
    if (!pickerInicio || !pickerFin) return;
    if (new Date(pickerFin) < new Date(pickerInicio)) return;
    setFechaInicio(pickerInicio);
    setFechaFin(pickerFin);
    setPeriodo('custom');
    setMostrarCustom(false);
  }

  const diaHoy    = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
  const maxVenta  = datos ? Math.max(...datos.ventasPorDia, 1) : 1;
  const maxEstado = datos ? Math.max(...Object.values(datos.porEstado), 1) : 1;

  if (cargando && !datos) return <div style={S.loading}>Cargando dashboard...</div>;

  return (
    <div style={S.container}>
      <div style={S.selectorWrap}>
        {['hoy','semana','mes'].map(p => (
          <button key={p} style={{ ...S.selectorBtn, ...(periodo===p&&!mostrarCustom?S.selectorBtnActive:{}) }}
            onClick={() => { setPeriodo(p); setMostrarCustom(false); }}>
            {p==='hoy'?'Hoy':p==='semana'?'Semana':'Mes'}
          </button>
        ))}
        <button style={{ ...S.selectorBtn, ...(periodo==='custom'||mostrarCustom?S.selectorBtnActive:{}) }}
          onClick={() => setMostrarCustom(v => !v)}>
          📅 Elegir
        </button>
      </div>

      {mostrarCustom && (
        <div style={S.customWrap}>
          <div style={S.customRow}>
            <div style={S.customField}>
              <label style={S.customLabel}>Desde</label>
              <input type="date" style={S.dateInput} value={pickerInicio} max={hoyStr}
                onChange={e => { setPickerInicio(e.target.value); setPickerFin(''); }} />
            </div>
            <div style={S.customField}>
              <label style={S.customLabel}>Hasta</label>
              <input type="date" style={S.dateInput} value={pickerFin} min={pickerInicio} max={hoyStr}
                onChange={e => setPickerFin(e.target.value)} />
            </div>
          </div>
          <button style={S.aplicarBtn} onClick={aplicarCustom}>Aplicar</button>
        </div>
      )}

      <div style={S.grid2}>
        <div style={S.card}>
          <div style={S.cardLbl}>Ventas {periodo==='hoy'?'del día':periodo==='semana'?'esta semana':periodo==='mes'?'este mes':'del período'}</div>
          <div style={S.cardVal}>{formatPesos(datos.ventas)}</div>
        </div>
        <div style={S.card}>
          <div style={S.cardLbl}>Pedidos</div>
          <div style={S.cardVal}>{datos.totalPedidos}</div>
        </div>
      </div>

      <div style={S.grid2}>
        <div style={S.card}>
          <div style={S.cardLbl}>Chats abiertos</div>
          <div style={S.cardVal}>—</div>
          <div style={S.cardSub}>Próximamente</div>
        </div>
        <div style={S.card}>
          <div style={S.cardLbl}>Conversión</div>
          <div style={S.cardVal}>—</div>
          <div style={S.cardSub}>chats → ventas</div>
        </div>
      </div>

      {(datos.alertaNuevos > 0 || datos.alertaRevision > 0 || datos.alertaCancelado > 0) && (
        <div style={S.alertaWrap}>
          <div style={S.alertaTitulo}>⚠ Pendientes de atender</div>
          <div style={S.alertaPills}>
            {datos.alertaNuevos > 0 && (
              <span style={{ ...S.pillNaranja, cursor:'pointer' }}
                onClick={() => onNavegar && onNavegar('pedidos','pendiente')}>
                {datos.alertaNuevos} Pendientes →
              </span>
            )}
            {datos.alertaRevision > 0 && (
              <span style={{ ...S.pillAzul, cursor:'pointer' }}
                onClick={() => onNavegar && onNavegar('pedidos','revision')}>
                {datos.alertaRevision} Revisión →
              </span>
            )}
            {datos.alertaCancelado > 0 && (
              <span style={{ ...S.pillRosa, cursor:'pointer' }}
                onClick={() => onNavegar && onNavegar('pedidos','cancelado')}>
                {datos.alertaCancelado} Cancelado →
              </span>
            )}
          </div>
        </div>
      )}

      <div style={S.grid2}>
        <div style={{ ...S.card, background:'#fff3e0', borderColor:'#ffcc80' }}>
          <div style={{ ...S.cardLbl, color:'#633806' }}>Stock bajo</div>
          <div style={{ ...S.cardVal, color:'#e65100' }}>{datos.stockBajo}</div>
          <div style={{ ...S.cardSub, color:'#854F0B' }}>variantes</div>
        </div>
        <div style={{ ...S.card, background:'#ffebee', borderColor:'#ffcdd2' }}>
          <div style={{ ...S.cardLbl, color:'#501313' }}>Agotados</div>
          <div style={{ ...S.cardVal, color:'#c62828' }}>{datos.agotados}</div>
          <div style={{ ...S.cardSub, color:'#A32D2D' }}>variantes</div>
        </div>
      </div>

      <div style={S.cardFull}>
        <div style={S.secTitle}>Pedidos por estado</div>
        <BarraEstado label="Entregados / Recogidos" valor={datos.porEstado.entregado}  max={maxEstado} color="#25D366" />
        <BarraEstado label="Enviados"               valor={datos.porEstado.enviado}    max={maxEstado} color="#1565c0" />
        <BarraEstado label="Confirmados"             valor={datos.porEstado.confirmado} max={maxEstado} color="#128C7E" />
        <BarraEstado label="Pendientes"              valor={datos.porEstado.pendiente}  max={maxEstado} color="#f57f17" />
        <BarraEstado label="En revisión"             valor={datos.porEstado.revision}   max={maxEstado} color="#880e4f" />
      </div>

      <div style={S.cardFull}>
        <div style={S.secTitle}>Productos más vendidos</div>
        {datos.topProductos.length === 0 && (
          <div style={{ fontSize:12, color:'#7A8F89', textAlign:'center', padding:16 }}>Sin datos de ventas aún</div>
        )}
        {datos.topProductos.map((p, i) => (
          <div key={i} style={S.prodRow}>
            <span style={S.prodEmoji}>{p.emoji}</span>
            <div style={S.prodInfo}>
              <div style={S.prodNombre}>{p.nombre}</div>
              <div style={S.prodBarBg}>
                <div style={{ ...S.prodBarFill, width:`${Math.round((p.qty/datos.maxQty)*100)}%` }} />
              </div>
            </div>
            <div style={S.prodQty}>{p.qty}</div>
          </div>
        ))}
      </div>

      <div style={S.cardFull}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:14 }}>
          <div style={S.secTitle}>Ventas por día</div>
          <div style={{ fontSize:11, color:'#7A8F89' }}>Total: {formatPesos(datos.ventas)}</div>
        </div>
        <div style={S.graficaWrap}>
          <div style={S.ejeY}>
            {[maxVenta, Math.round(maxVenta*0.75), Math.round(maxVenta*0.5), Math.round(maxVenta*0.25), 0].map((v,i) => (
              <div key={i} style={S.ejeYLabel}>{v > 0 ? '$'+Math.round(v/1000)+'k' : '$0'}</div>
            ))}
          </div>
          <div style={S.barrasWrap}>
            {datos.ventasPorDia.map((v, i) => {
              const pct = maxVenta > 0 ? (v/maxVenta)*100 : 0;
              const esHoy = i === diaHoy;
              return (
                <div key={i} style={S.barCol}>
                  <div style={S.barValLabel}>{v > 0 ? formatPesos(v) : ''}</div>
                  <div style={S.barTrack}>
                    <div style={{ ...S.barFill, height:`${pct}%`, background: esHoy?'#25D366':'#c8e6c9' }} />
                  </div>
                  <div style={{ ...S.barDiaLabel, color: esHoy?'#128C7E':'#7A8F89', fontWeight: esHoy?700:400 }}>
                    {DIAS[i]}{esHoy?' ●':''}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{ fontSize:10, color:'#7A8F89', marginTop:8 }}>Se actualiza según el período seleccionado</div>
      </div>
    </div>
  );
}

const S = {
  container:         { padding:16, paddingBottom:90 },
  loading:           { padding:40, textAlign:'center', color:'#7A8F89' },
  selectorWrap:      { display:'flex', background:'white', borderRadius:10, border:'1px solid #E4EDE8', overflow:'hidden', marginBottom:12 },
  selectorBtn:       { flex:1, padding:'9px 4px', border:'none', background:'none', fontSize:11, color:'#7A8F89', cursor:'pointer', fontFamily:'inherit' },
  selectorBtnActive: { background:'#075E54', color:'white', borderRadius:8 },
  customWrap:        { background:'white', borderRadius:12, border:'1px solid #E4EDE8', padding:12, marginBottom:12 },
  customRow:         { display:'flex', gap:10, marginBottom:10 },
  customField:       { flex:1 },
  customLabel:       { display:'block', fontSize:11, color:'#7A8F89', marginBottom:4 },
  dateInput:         { width:'100%', background:'#F0F4F0', border:'1px solid #E4EDE8', borderRadius:8, padding:'8px 10px', fontSize:12, color:'#0D1F1A', outline:'none', boxSizing:'border-box' },
  aplicarBtn:        { width:'100%', background:'#128C7E', color:'white', border:'none', borderRadius:8, padding:10, fontSize:13, fontWeight:700, cursor:'pointer' },
  grid2:             { display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 },
  card:              { background:'white', borderRadius:12, padding:'12px 14px', border:'1px solid #E4EDE8' },
  cardLbl:           { fontSize:11, color:'#7A8F89', marginBottom:6 },
  cardVal:           { fontSize:22, fontWeight:800, color:'#0D1F1A' },
  cardSub:           { fontSize:11, color:'#7A8F89', marginTop:4 },
  alertaWrap:        { background:'#fff8e1', border:'1px solid #f9a825', borderRadius:12, padding:'10px 14px', marginBottom:10 },
  alertaTitulo:      { fontSize:12, fontWeight:700, color:'#633806', marginBottom:8 },
  alertaPills:       { display:'flex', gap:6, flexWrap:'wrap' },
  pillNaranja:       { background:'#f57f17', color:'white', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700 },
  pillAzul:          { background:'#e3f2fd', color:'#0C447C', borderRadius:20, padding:'3px 10px', fontSize:11 },
  pillRosa:          { background:'#fce4ec', color:'#880e4f', borderRadius:20, padding:'3px 10px', fontSize:11 },
  cardFull:          { background:'white', borderRadius:12, padding:'14px 16px', border:'1px solid #E4EDE8', marginBottom:10 },
  secTitle:          { fontSize:13, fontWeight:700, color:'#0D1F1A', marginBottom:14 },
  prodRow:           { display:'flex', alignItems:'center', gap:10, marginBottom:12 },
  prodEmoji:         { fontSize:22 },
  prodInfo:          { flex:1 },
  prodNombre:        { fontSize:12, fontWeight:700, color:'#0D1F1A', marginBottom:4 },
  prodBarBg:         { height:6, background:'#F0F4F0', borderRadius:3, overflow:'hidden' },
  prodBarFill:       { height:'100%', background:'#25D366', borderRadius:3 },
  prodQty:           { fontSize:13, fontWeight:700, color:'#128C7E', minWidth:28, textAlign:'right' },
  graficaWrap:       { display:'flex', gap:8, height:160 },
  ejeY:              { display:'flex', flexDirection:'column', justifyContent:'space-between', alignItems:'flex-end', paddingBottom:20 },
  ejeYLabel:         { fontSize:9, color:'#7A8F89' },
  barrasWrap:        { flex:1, display:'flex', alignItems:'flex-end', gap:4 },
  barCol:            { flex:1, display:'flex', flexDirection:'column', alignItems:'center', height:'100%' },
  barValLabel:       { fontSize:8, color:'#7A8F89', marginBottom:2, textAlign:'center', minHeight:12 },
  barTrack:          { flex:1, width:'100%', display:'flex', alignItems:'flex-end' },
  barFill:           { width:'100%', borderRadius:'4px 4px 0 0', minHeight:2, transition:'height .3s' },
  barDiaLabel:       { fontSize:10, marginTop:4 },
};

export default Stats;